import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        ref={ref}
        {...props}
    >
        <mask id="ursa-icon__InfoIcon__16__ida" fill="#fff">
            <path
                fillRule="evenodd"
                d="M8 7.6a.65.65 0 0 1 .65.65v2.25a.65.65 0 1 1-1.3 0V8.25A.65.65 0 0 1 8 7.6"
                clipRule="evenodd"
            />
            <path
                fillRule="evenodd"
                d="M8 3.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
                clipRule="evenodd"
            />
            <path d="M7.25 5.95a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0" />
        </mask>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8 7.6a.65.65 0 0 1 .65.65v2.25a.65.65 0 1 1-1.3 0V8.25A.65.65 0 0 1 8 7.6"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8 3.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M7.25 5.95a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0" />
        <path
            fill="currentColor"
            d="M8 11.15v-1zm-.75-5.2h-1zM8 5.2v1zm.75.75h-1zM8 6.7v1zm1.65 1.55A1.65 1.65 0 0 0 8 6.6v2a.35.35 0 0 1-.35-.35zm0 2.25V8.25h-2v2.25zM8 12.15a1.65 1.65 0 0 0 1.65-1.65h-2a.35.35 0 0 1 .35-.35zM6.35 10.5c0 .911.739 1.65 1.65 1.65v-2a.35.35 0 0 1 .35.35zm0-2.25v2.25h2V8.25zM8 6.6a1.65 1.65 0 0 0-1.65 1.65h2A.35.35 0 0 1 8 8.6zM4.4 8A3.6 3.6 0 0 1 8 4.4v-2A5.6 5.6 0 0 0 2.4 8zM8 11.6A3.6 3.6 0 0 1 4.4 8h-2A5.6 5.6 0 0 0 8 13.6zM11.6 8A3.6 3.6 0 0 1 8 11.6v2A5.6 5.6 0 0 0 13.6 8zM8 4.4A3.6 3.6 0 0 1 11.6 8h2A5.6 5.6 0 0 0 8 2.4zM8 1a7 7 0 0 0-7 7h2a5 5 0 0 1 5-5zm7 7a7 7 0 0 0-7-7v2a5 5 0 0 1 5 5zm-7 7a7 7 0 0 0 7-7h-2a5 5 0 0 1-5 5zM1 8a7 7 0 0 0 7 7v-2a5 5 0 0 1-5-5zm7.25-2.05A.25.25 0 0 1 8 6.2v-2a1.75 1.75 0 0 0-1.75 1.75zM8 6.2a.25.25 0 0 1-.25-.25h2A1.75 1.75 0 0 0 8 4.2zm-.25-.25A.25.25 0 0 1 8 5.7v2a1.75 1.75 0 0 0 1.75-1.75zM8 5.7a.25.25 0 0 1 .25.25h-2c0 .966.783 1.75 1.75 1.75z"
            mask="url(#ursa-icon__InfoIcon__16__ida)"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
